import React from 'react'
import { Row } from 'react-bootstrap'
import ItemCard from '../../common/shop/itemCard'
import PageTitle from '../shop/common/pageTitle'
import styles from './listing.module.css'
import constants from '../../../config/constants'

interface Job {
  id: string
  title: string
  thumbUrl: string
  link: string
}

const JobListing = () => {
  return (
    <div>
      <PageTitle title="Jobs" />

      <Row className={styles.listingWrapper} data-testid="jobListingContainer">
        {constants.jobs.map(job => {
          return (
            <ItemCard
              key={job.id}
              thumbImageUrl={job.thumbUrl}
              title={job.title}
              onClick={() => {
                window.open(job.link, '_blank')
              }}
            />
          )
        })}
      </Row>
    </div>
  )
}

export default JobListing
